<template>
  <div class="container -mt-1 ">
    <div class="grid md:grid-cols-3 grid-cols-1 mt-8 gap-[30px]">

      <product-card-item />
    </div>
  </div>
</template>

<script>
import ProductCardItem from './ProductCardItem.vue'
export default {
  components: { ProductCardItem },

}
</script>

<style></style>